/* Personalises the B2B thank-you page with the visitor's name.
 *
 * The page is a plain Shopify page (fully cached, no per-visitor Liquid), so the
 * name has to travel from the form on the client. It arrives two ways and either
 * is enough:
 *
 *   1. `?name=` on the URL, appended by frido-b2b-form.js when it redirects.
 *   2. sessionStorage, written by the form as the visitor types their name —
 *      the fallback when the query string is stripped by a redirect or an app.
 *
 * The query string is removed once read, so the address bar settles on the clean
 * .../thank-you URL and the name isn't carried into anything the visitor shares.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'frido-b2b-lead-name';
  var MAX_LENGTH = 60;

  function fromStorage() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      /* Private mode / blocked storage — the query string is the fallback. */
      return '';
    }
  }

  function readName() {
    var fromQuery = '';
    try {
      fromQuery = new URLSearchParams(window.location.search).get('name') || '';
    } catch (error) {
      fromQuery = '';
    }

    var name = (fromQuery || fromStorage()).trim();
    if (!name) return '';

    /* Keep it to something that plausibly is a name: one line, bounded length.
       It's written with textContent, so this is tidiness rather than escaping. */
    name = name.replace(/\s+/g, ' ');
    return name.length > MAX_LENGTH ? name.slice(0, MAX_LENGTH).trim() : name;
  }

  function stripQuery() {
    if (!window.history || !window.history.replaceState) return;
    if (window.location.search.indexOf('name=') === -1) return;

    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('name');
      var query = url.searchParams.toString();
      window.history.replaceState(
        window.history.state,
        '',
        url.pathname + (query ? '?' + query : '') + url.hash
      );
    } catch (error) {
      /* Cosmetic only — leave the URL alone if anything about it is unusual. */
    }
  }

  function init(scope) {
    var section = (scope || document).querySelector('[data-b2b-thankyou]');
    if (!section) return;

    var name = readName();
    if (name) {
      /* Re-store, so a refresh (which has no query string) still greets them. */
      try {
        window.sessionStorage.setItem(STORAGE_KEY, name);
      } catch (error) {
        /* Non-fatal. */
      }

      var greeting = section.querySelector('[data-b2b-greeting]');
      var slot = section.querySelector('[data-b2b-greeting-name]');
      if (slot) slot.textContent = name;
      if (greeting) greeting.hidden = false;
    }

    stripQuery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
